import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { logEvent } from "firebase/analytics";
import { analyticsObj, getFreshProductPackages } from "../../../components/firebase/firestore";
import Loading from "../../../components/misc/Loading";
import useFreshProducts from "./useFreshProducts";
import FarmProductDetails from "./FarmProductDetails";
import "./farmProductPage.css";

export default function FarmProductPage() {
  const { productId } = useParams();
  const language = useSelector((state) => state.app.language);
  const sv = language === 0;
  const { products, loading, error, retry } = useFreshProducts(productId);
  const [product, setProduct] = useState(null);
  const [packageError, setPackageError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => { window.scrollTo(0, 0); }, [productId]);
  useEffect(() => {
    let active = true;
    setProduct(null);
    setPackageError(false);
    if (loading || error) return;
    const result = products.find((item) => item.link === productId);
    if (!result) return;
    getFreshProductPackages(result.id).then((packages) => {
      if (!active) return;
      setProduct({ ...result, packages });
      logEvent(analyticsObj, "page_view", { name: result.id });
    }).catch(() => { if (active) setPackageError(true); });
    return () => { active = false; };
  }, [productId, products, loading, error, attempt]);

  if (product) return <FarmProductDetails key={product.firebaseId} product={product} language={language} />;
  const failed = error || packageError;
  const missing = !loading && !error && !products.some((item) => item.link === productId);
  if (!failed && !missing) return <main className="AppLoading" role="status" aria-label={sv ? "Laddar produkt" : "Loading product"} aria-busy="true"><Loading /></main>;
  return <main className="ProductDetail ProductDetailState">
    <Link to="/farm" className="ProductWordmark">VERT<span>.farm</span></Link>
    <div role={failed ? "alert" : "status"}>
      <p className="ProductEyebrow">{sv ? "FRÅN VÅR ODLING" : "FROM OUR FARM"}</p>
      <h1>{failed ? (sv ? "Vi kunde inte hämta produkten." : "We couldn't load this product.") : (sv ? "Produkten hittades inte." : "Product not found.")}</h1>
      {failed && <button className="ProductButton" onClick={error ? retry : () => setAttempt((value) => value + 1)}>{sv ? "Försök igen" : "Try again"}</button>}
    </div>
    <Link className="ProductTextLink" to="/farm/products/fresh">{sv ? "Till färska produkter" : "Back to fresh products"} →</Link>
  </main>;
}
